module.exports = __webpack_public_path__ + "img/标准文件2.5a30578b.png";